import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { api, safeInternalPath } from "../api";
import { toast } from "sonner";

export default function ConfirmEmail() {
  const { t } = useTranslation();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [email, setEmail] = useState(sp.get("email") || "");
  const [code, setCode] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/confirm-email", { email, code });
      toast.success("Email confermata");
      const nextPath = safeInternalPath(sp.get("next"));
      nav(`/login${nextPath ? `?next=${encodeURIComponent(nextPath)}` : ""}`);
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
  };
  const resend = async () => {
    try {
      const fd = new FormData(); fd.append("email", email);
      await api.post("/auth/resend-code", fd);
      toast.info("Nuovo codice inviato");
    } catch { toast.error("Errore"); }
  };
  return (<Layout><div className="yp-container max-w-md py-12">
    <h1 className="text-2xl font-bold mb-2">{t("auth.confirm_email_title")}</h1>
    <p className="text-sm text-slate-500 mb-6">{t("auth.confirm_email_sub")}</p>
    <form onSubmit={submit} className="yp-card p-6 space-y-4">
      <input required className="yp-input" type="email" placeholder="email" value={email} onChange={e=>setEmail(e.target.value)} data-testid="confirm-email" />
      <input required className="yp-input tracking-widest text-center" placeholder="000000" value={code} onChange={e=>setCode(e.target.value)} data-testid="confirm-code" />
      <button className="yp-btn yp-btn-primary w-full" type="submit" data-testid="confirm-submit">{t("common.confirm")}</button>
      <button type="button" className="yp-btn yp-btn-ghost w-full" onClick={resend} data-testid="confirm-resend">Rinvia codice</button>
    </form>
  </div></Layout>);
}
